"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoraBDSNeo3 = void 0;
const api_1 = require("@cityofzion/dora-ts/dist/api");
const neon_js_1 = require("@cityofzion/neon-js");
const BSNeo3Helper_1 = require("../../helpers/BSNeo3Helper");
const RpcBDSNeo3_1 = require("./RpcBDSNeo3");
const NeoRest = new api_1.NeoRESTApi({
    doraUrl: 'https://dora.coz.io',
    endpoint: '/api/v2/neo3',
});
class DoraBDSNeo3 extends RpcBDSNeo3_1.RpcBDSNeo3 {
    constructor(network, feeToken, claimToken, tokens) {
        super(network, feeToken, claimToken, tokens);
    }
    getTransaction(hash) {
        const _super = Object.create(null, {
            getTransaction: { get: () => super.getTransaction }
        });
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (BSNeo3Helper_1.BSNeo3Helper.isCustomNet(this._network)) {
                return yield _super.getTransaction.call(this, hash);
            }
            try {
                const data = yield NeoRest.transaction(hash, this._network.id);
                return {
                    block: data.block,
                    time: Number(data.time),
                    hash: data.hash,
                    fee: neon_js_1.u.BigInteger.fromNumber((_a = data.netfee) !== null && _a !== void 0 ? _a : 0)
                        .add(neon_js_1.u.BigInteger.fromNumber((_b = data.sysfee) !== null && _b !== void 0 ? _b : 0))
                        .toDecimal(this._feeToken.decimals),
                    notifications: [],
                    transfers: [],
                };
            }
            catch (_c) {
                throw new Error(`Transaction not found: ${hash}`);
            }
        });
    }
    getTransactionsByAddress({ address, nextPageParams = 1, }) {
        const _super = Object.create(null, {
            getTransactionsByAddress: { get: () => super.getTransactionsByAddress }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (BSNeo3Helper_1.BSNeo3Helper.isCustomNet(this._network)) {
                return yield _super.getTransactionsByAddress.call(this, { address, nextPageParams });
            }
            const data = yield NeoRest.addressTXFull(address, nextPageParams, this._network.id);
            const promises = data.items.map((item) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const transferPromises = [];
                item.notifications.forEach(({ contract: contractHash, state, event_name: eventName }) => {
                    const properties = Array.isArray(state) ? state : state.value;
                    if (eventName !== 'Transfer' || (properties.length !== 3 && properties.length !== 4))
                        return;
                    const promise = () => __awaiter(this, void 0, void 0, function* () {
                        var _a;
                        const isAsset = properties.length === 3;
                        const from = properties[0].value;
                        const to = properties[1].value;
                        const convertedFrom = from ? this.convertByteStringToAddress(from) : 'Mint';
                        const convertedTo = to ? this.convertByteStringToAddress(to) : 'Burn';
                        if (isAsset) {
                            const token = yield this.getTokenInfo(contractHash);
                            const [, , { value: amount }] = properties;
                            return {
                                amount: neon_js_1.u.BigInteger.fromNumber(amount).toDecimal((_a = token.decimals) !== null && _a !== void 0 ? _a : 0),
                                from: convertedFrom,
                                to: convertedTo,
                                contractHash,
                                type: 'token',
                                token,
                            };
                        }
                        return {
                            from: convertedFrom,
                            to: convertedTo,
                            tokenId: properties[3].value,
                            contractHash,
                            type: 'nft',
                        };
                    });
                    transferPromises.push(promise());
                });
                const transfers = yield Promise.all(transferPromises);
                const notifications = item.notifications.map(notification => ({
                    eventName: notification.event_name,
                    state: notification.state,
                }));
                return {
                    block: item.block,
                    time: Number(item.time),
                    hash: item.hash,
                    fee: neon_js_1.u.BigInteger.fromNumber((_a = item.netfee) !== null && _a !== void 0 ? _a : 0)
                        .add(neon_js_1.u.BigInteger.fromNumber((_b = item.sysfee) !== null && _b !== void 0 ? _b : 0))
                        .toDecimal(this._feeToken.decimals),
                    transfers,
                    notifications,
                };
            }));
            const transactions = yield Promise.all(promises);
            const limit = 15;
            const totalPages = Math.ceil(data.totalCount / limit);
            return {
                nextPageParams: nextPageParams < totalPages ? nextPageParams + 1 : undefined,
                transactions,
            };
        });
    }
    getContract(contractHash) {
        const _super = Object.create(null, {
            getContract: { get: () => super.getContract }
        });
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (BSNeo3Helper_1.BSNeo3Helper.isCustomNet(this._network)) {
                return yield _super.getContract.call(this, contractHash);
            }
            try {
                const data = yield NeoRest.contract(contractHash, this._network.id);
                return {
                    hash: data.hash,
                    methods: (_b = (_a = data.manifest.abi) === null || _a === void 0 ? void 0 : _a.methods) !== null && _b !== void 0 ? _b : [],
                    name: data.manifest.name,
                };
            }
            catch (_c) {
                throw new Error(`Contract not found: ${contractHash}`);
            }
        });
    }
    getTokenInfo(tokenHash) {
        const _super = Object.create(null, {
            getTokenInfo: { get: () => super.getTokenInfo }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (BSNeo3Helper_1.BSNeo3Helper.isCustomNet(this._network)) {
                return yield _super.getTokenInfo.call(this, tokenHash);
            }
            const localToken = this._tokens.find(token => token.hash === tokenHash);
            if (localToken)
                return localToken;
            if (this._tokenCache.has(tokenHash)) {
                return this._tokenCache.get(tokenHash);
            }
            try {
                const { decimals, symbol, name, scripthash } = yield NeoRest.asset(tokenHash, this._network.id);
                const token = {
                    decimals: Number(decimals),
                    symbol,
                    name,
                    hash: scripthash,
                };
                this._tokenCache.set(tokenHash, token);
                return token;
            }
            catch (_a) {
                throw new Error(`Token not found: ${tokenHash}`);
            }
        });
    }
    getBalance(address) {
        const _super = Object.create(null, {
            getBalance: { get: () => super.getBalance }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (BSNeo3Helper_1.BSNeo3Helper.isCustomNet(this._network)) {
                return yield _super.getBalance.call(this, address);
            }
            const response = yield NeoRest.balance(address, this._network.id);
            const promises = response.map((balance) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const token = yield this.getTokenInfo(balance.asset);
                    return {
                        amount: balance.balance.toString(),
                        token,
                    };
                }
                catch (_a) {
                    // Empty block
                }
            }));
            const balances = yield Promise.all(promises);
            const filteredBalances = balances.filter(balance => balance !== undefined);
            return filteredBalances;
        });
    }
    convertByteStringToAddress(byteString) {
        const account = new neon_js_1.wallet.Account(neon_js_1.u.reverseHex(neon_js_1.u.HexString.fromBase64(byteString).toString()));
        return account.address;
    }
}
exports.DoraBDSNeo3 = DoraBDSNeo3;
